
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minu/seaded/keel",
      function () {
        return require("private-next-pages/minu/seaded/keel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/minu/seaded/keel"])
      });
    }
  